define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../utils/LookupDataSources", "../../models/UserContext", "../../models/ProductCategoryModel"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, LookupDataSources, UserContext, ProductCategoryModel) {
    "use strict";
    var ProductCategory = /** @class */ (function () {
        function ProductCategory() {
            this.userCanEditProductCategory = ko.observable(UserContext.hasAccess("Admin,ProductCategory.Edit,ProductCategory.Delete"));
            this.userCanDeleteProductCategory = ko.observable(UserContext.hasAccess("Admin,ProductCategory.Delete"));
            this.filterByAny = ko.observable("");
            this.editModel = ko.observable(new ProductCategoryModel());
            this.permissionModelTable = ko.observableArray();
        }
        ProductCategory.prototype.init = function () {
            var self = this;
            $("#page-title").text("Product Categories");
            tools.ajaxGet({
                url: "/ProductCategory/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.productCategoryLookupList = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.productCategoryLookupList.GridStructures.ProductCategoryStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        ProductCategory.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblProductCategoryKendo";
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "100px",
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEditProductCategory()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if (self.userCanDeleteProductCategory()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.productCategoryTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/ProductCategory/GetProductCategories",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#productcategory-toolbar-template").html()),
                    columns: columns
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "ProductCategory",
                    title: "Product Categories",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.productCategoryTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.productCategoryTable.getGridData().dataSource.read();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editProductCategory(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deleteProductCategoryConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        ProductCategory.prototype.editProductCategory = function (id) {
            var self = this;
            var title = "Add New Product Category";
            if (!isNaN(id)) {
                title = "Edit Product Category";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Product category name is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveProductCategory(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/ProductCategory/GetProductCategoryById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new ProductCategoryModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new ProductCategoryModel());
                    }
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'pc-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        var lookupDataSources = new LookupDataSources();
                        var dataSource = lookupDataSources.createLookupDataSource("ProductCategories", {
                            serverPaging: false,
                            serverFiltering: false
                        });
                        self.parentCategoryDropDown = $("input[name=ParentId]", modal).kendoDropDownList({
                            dataSource: dataSource,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            filter: "contains",
                            optionLabel: "Select Category",
                            popup: {
                                appendTo: $(".modal-body", modal)
                            }
                        }).data("kendoDropDownList");
                        //log.log(parentDropDown);
                    });
                }
            });
        };
        ProductCategory.prototype.saveProductCategory = function (btn, modal) {
            var self = this;
            self.editModel().ParentId(self.parentCategoryDropDown.value());
            var data = tools.modelToFormData(self.editModel());
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/ProductCategory/SaveProductCategory",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.productCategoryTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        ProductCategory.prototype.deleteProductCategory = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/ProductCategory/DeleteProductCategoryConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Product category deleted successfully");
                    self.productCategoryTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        ProductCategory.prototype.deleteProductCategoryConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete Product Category",
                text: "Are you sure you want to delete product category " + name + "?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteProductCategory(id);
            });
        };
        return ProductCategory;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/ProductCategory/Index")) {
            log.log("Initialize Product Category list");
            $(function () {
                (new ProductCategory()).init();
            });
        }
    }, 0);
    return ProductCategory;
});
//# sourceMappingURL=productCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/productCategory/productCategory.js
// module id = 290
// module chunks = 2